import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui'
import { APP, ROUTES } from '@/config'

export interface ErrorLayoutProps {
  code: string
  title: string
  description: string
  children?: ReactNode
  /** Hidden on screens the user reached without a session. */
  showHomeLink?: boolean
}

/** Shared frame for the dedicated status pages (404, 403, 401, 500). */
export function ErrorLayout({
  code,
  title,
  description,
  children,
  showHomeLink = true,
}: ErrorLayoutProps) {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-6 px-4 text-center">
      <p className="text-muted-foreground/40 text-7xl font-bold tracking-tighter select-none">
        {code}
      </p>

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold">{title}</h1>
        <p className="text-muted-foreground max-w-md text-sm">{description}</p>
      </div>

      {children}

      {showHomeLink ? (
        <Button asChild>
          <Link to={ROUTES.dashboard}>Voltar para o início</Link>
        </Button>
      ) : null}

      <p className="text-muted-foreground text-xs">{APP.name}</p>
    </div>
  )
}
